export default __webpack_public_path__ + "static/media/details_icon_hover.78e96eec.svg";